import React, { useEffect, useState } from "react";

import { Chip, TextField, makeStyles } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import LocalOfferOutlinedIcon from "@material-ui/icons/LocalOfferOutlined";

import api from "../../services/api";
import openSocket from "../../services/socket-io";
import toastError from "../../errors/toastError";
import { i18n } from "../../translate/i18n";
import { contrastText } from "../../helpers/contrastText";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    padding: theme.spacing(0.5, 2),
    borderBottom: theme.border.divider,
    backgroundColor: theme.palette.background.paper,
  },
  icon: {
    color: theme.palette.text.secondary,
    fontSize: 20,
  },
  autocomplete: {
    flex: 1,
  },
  input: {
    "& .MuiInput-underline:before": {
      borderBottom: "none",
    },
  },
}));

const TicketTagsSelect = ({ ticket }) => {
  const classes = useStyles();
  const [tags, setTags] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/tags");
        setTags(data);
      } catch (err) {
        toastError(err);
      }
    })();

    const socket = openSocket();
    socket.on("tag", (data) => {
      if (data.action === "update") {
        setTags((prev) => [...prev.filter((t) => t.id !== data.tag.id), data.tag]);
      }
      if (data.action === "delete") {
        setTags((prev) => prev.filter((t) => t.id !== data.tagId));
      }
    });

    return () => socket.disconnect();
  }, []);

  const handleChange = async (event, selected) => {
    try {
      await api.put(`/tickets/${ticket.id}/tags`, {
        tagIds: selected.map((tag) => tag.id),
      });
    } catch (err) {
      toastError(err);
    }
  };

  if (!ticket.id) return null;

  return (
    <div className={classes.root}>
      <LocalOfferOutlinedIcon className={classes.icon} />
      <Autocomplete
        multiple
        size="small"
        className={classes.autocomplete}
        options={tags}
        value={ticket.tags || []}
        getOptionLabel={(option) => option.name}
        getOptionSelected={(option, value) => option.id === value.id}
        onChange={handleChange}
        filterSelectedOptions
        noOptionsText={i18n.t("ticketTags.noOptions")}
        renderTags={(value, getTagProps) =>
          value.map((tag, index) => (
            <Chip
              {...getTagProps({ index })}
              key={tag.id}
              size="small"
              label={tag.name}
              style={{ backgroundColor: tag.color, color: contrastText(tag.color) }}
            />
          ))
        }
        renderInput={(params) => (
          <TextField
            {...params}
            className={classes.input}
            placeholder={ticket.tags?.length ? "" : i18n.t("ticketTags.placeholder")}
          />
        )}
      />
    </div>
  );
};

export default TicketTagsSelect;
